export default "__VITE_ASSET__Dm12JijY__"